const routes = [
  {
    component: () =>
      import(
        /* webpackChunkName: "settings-index" */ "@/pages/Settings/SettingsIndex"
      ),
    name: "MySettings",
    path: "/settings",
    meta: {
      title: "Settings - Nutribit",
      showSearch: true
    }
  },
  {
    path: "/settings/profile",
    component: () =>
      import(
        /* webpackChunkName: "settings-index" */ "@/pages/Settings/ProfileIndex"
      ),
    name: "MyProfile",
    meta: {
      title: "Profile - Nutribit",
      showSearch: true
    }
  }
];

export default routes;
